






























import { Component, Vue, Prop } from 'nuxt-property-decorator'

interface MBriefTaskModel {
  text: string;
  files: File[];
}

@Component<MBriefTask>({})
export default class MBriefTask extends Vue {
  @Prop({ default: undefined }) value!: MBriefTaskModel

  model: MBriefTaskModel = {
    text: '',
    files: []
  }

  mounted() {
    if (this.value) {
      this.model.text = this.value.text || ''
      this.model.files = this.value.files || []
    }

    this.$on('input', (value: MBriefTaskModel) => {
      this.model.text = value.text
      this.model.files = value.files
    })
  }

  onInput(event: InputEvent) {
    const el = event.target as HTMLTextAreaElement
    el.style.height = "auto"
    el.style.height = `${el.scrollHeight}px`

    this.onModelChange()
  }

  fileInput(event: InputEvent) {
    const el = event.target as HTMLInputElement
    if (el) {
      const files = el.files

      if (files) {
        for (let i = 0; i < files.length; i++) {
          if (files[i].type !== 'image/jpeg' && files[i].type !== 'image/png' && files[i].type !== 'application/pdf') {
            alert('Tylko obrazy PNG i JPG oraz dokumenty PDF')
            continue
          }

          if (this.model.files.length >= 5) {
            alert('Maksymalna liczba plików to 5')
            break
          }

          this.model.files.push(files[i])
        }

        this.onModelChange()

        el.value = ''
      }
    }
  }

  removeFile(index: number) {
    this.model.files.splice(index, 1)
  }

  onModelChange() {
    this.$emit('input', this.model)
  }
}
